<template>
  <div id="app">
    <router-view />
    <!-- <el-footer v-if="provider" class="main-bottom" style="height: 35px;">{{ provider }}</el-footer> -->
  </div>
</template>

<script>
import 'babel-polyfill'
import { initCustomerParam, getProvider } from '@/util/environmentUtil'
export default {
  name: 'App',
  data() {
    return {
      provider: getProvider()
    }
  },
  created() {
    /* 初始化客户信息 */
    initCustomerParam()
  }
}
</script>

<style lang="less">
html {
  height: 100%;

  body {
    margin: 0;
    height: 100%;
  }

  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background: #f8f8f8;
    min-height: 100%;
    position: relative;

    .main-bottom {
      width: 100%;
      color: #666666;
      font-size: 14px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      position: absolute;
      bottom: 0;
      border-top: 1px solid #e4e7ed;
      background: #f4f4f4;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue